<template>
  <billing-report-panel
    report-key="payments-batch"
    route="/reports/billing-payments-batch"
    file-name="pagamentos-por-lote.xlsx"
    period-label="Período do pagamento"
    :columns="columns"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Lote',
        'Convênio',
        'Data do pagamento',
        'Valor informado',
        'Valor pago',
        'Débitos por tipo (Tabela 27)',
        'Créditos por tipo (Tabela 27)',
        'Líquido recebido',
        'Diferença',
        'Subtotal por convênio',
      ],
    };
  },
};
</script>
